/**
 * BrandContainer
 *
 * --
 */
import React from 'react';
import BrandPresenter from './BrandPresenter';
import { useDefaultShopDataStack } from 'store';
import { STORE_URL } from 'utils';

const BrandContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { navigate, screenSize } = props;

  /* ===== Store ===== */
  const { shops } = useDefaultShopDataStack();

  /* ===== Data ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /**
   * 브랜드 목록 정제
   * --
   */
  const BrandList = React.useMemo(() => {
    if (!shops?.length) return [];

    const brand = shops?.filter((shop) => shop?.is_brand === 'Y');

    const newBrand = brand?.map((shop) => {
      const { shop_information_file, mall_information, ...rest } = shop;

      const files = shop_information_file?.reduce(
        (acc, cur) => {
          const { type } = cur;

          if (type === 'THUMBNAIL') {
            acc['thumbnail'] = `${STORE_URL}/${cur?.file_url}`;
          } else if (type === 'STORE') {
            acc['detail']?.push(cur);
          }

          return acc;
        },
        { thumbnail: null, detail: [] }
      );

      return {
        ...rest,
        ...mall_information,
        ...files,
      };
    });

    return newBrand;
  }, [shops]);

  /* ===== RENDER ===== */
  return (
    <>
      <BrandPresenter
        navigate={navigate}
        screenSize={screenSize}
        brand={BrandList}
      />
    </>
  );
};

export default BrandContainer;
